export default __webpack_public_path__ + "static/media/photo--lg--roustem.9c98eaf3.jpg";